import React from 'react';
import { useNavigate } from 'react-router-dom';

// Material UI
import AppBar from '@mui/material/AppBar';

// FontAwesomeIcons
import { Grid, Link, Stack } from '@mui/material';

// Import our store

// Types
interface Props {

}

const Footer = ({}: Props) => {
  return (
    <AppBar position="fixed" sx={{top: 'auto', bottom: 0, backgroundColor:'#202020'}}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-around"
        alignItems="center"
        sx={{
          height: '100%',
          textAlign: 'center',
          minHeight: '48px',
          flexWrap: 'wrap',
          rowGap: { xs: 0.5, sm: 2 },       // smaller row gap on xs
          columnGap: { xs: 0, sm: 2 },      // optional: adjust column gap
        }}
      >
        <Link
          href="mailto:MaryBeth.Dziewietin@umassmed.edu"
          color="inherit"
          underline="none"
          target="_blank"
          sx={{ fontSize: { xs: '0.75rem', sm: '1rem' } }} // smaller font on xs
        >
          Questions or Comments? Email us!
        </Link>

        <Link
          href="https://kmonopoli.github.io/"
          color="inherit"
          underline="none"
          target="_blank"
          sx={{ fontSize: { xs: '0.75rem', sm: '1rem' } }}
        >
          Model developed by Kathryn Monopoli
        </Link>

        <Link
          href="https://baileysostek.github.io/baileysostek"
          color="inherit"
          underline="none"
          target="_blank"
          sx={{ fontSize: { xs: '0.75rem', sm: '1rem' } }}
        >
          Portal developed by Bailey Sostek
        </Link>

        <Link
          href="https://forms.gle/qGXbMAfRVVpJP2cY9"
          color="inherit"
          underline="none"
          target="_blank"
          sx={{ fontSize: { xs: '0.75rem', sm: '1rem' } }}
        >
          Feedback Form
        </Link>
      </Stack>
    </AppBar>
  );
};

export default Footer;